<script>
import Endpoints from '../../../components/common/Endpoints';
import Common from '../../../components/common/Common';
import Request from '../../../components/common/Request';
import { mapActions } from 'vuex';

let type = "TRUCK_TRAILER";

const instanceateAddress = (addressObj, geo) => {
    addressObj.name = 'MAIN';
    if (geo.geometry.lat){
        addressObj.lat = geo.geometry.lat;
    }else return null;
    if (geo.geometry.lng){
        addressObj.lng = geo.geometry.lng;
    }else return null;

    return addressObj;
}

export default {
    init: (payload) => {
        const el = document.body;
        el.removeAttribute("class");
        $('.modal').modal('hide');
    },
     
    methods:{
        save: function(){
            $('#spinner').modal('toggle');
            this.errors = [];
            this.messageIdToast = null;
            let state = this;

            this.data.document = this.data.document.replace(/\//g, '').replace(/\./g, '').replace(/\-/g, '');
            
            if(this.data.mainCompany){
                this.data.mainCompany = this.data.mainCompany.replace(/\//g, '').replace(/\./g, '').replace(/\-/g, '');
            }
             Request.do(this, 'PUT', Request.getDefaultHeader(this), this.data,  `${Endpoints.companies.company}${state.lastDocument}`,
                (companyResponse)=>{//SUCCESS CALLBACK
                    $('#spinner').modal('toggle');
                    this.$eventHub.$emit('refreshList');
                    this.flashMessage.info(
                        this.configMessage(this.$t('string.msg.company.register.title.alter'), this.$t('string.msg.company.register.message.alter'), 'top left', 3000),
                    {
                        mounted: this.showText(this.$t('string.msg.company.register.message.alter')),
                        destroyed: this.clearText()
                    })
                },
                (error)=>{//ERROR CALLBACK
                    $('#spinner').modal('toggle');
                    let res = error.response;
                    if (res && res.status){
                        this.titleToast = this.$t("string.msg.warning");
                        if (res.data.messageId === 'response.msg.error.empty.fields'){
                            let fields = "";
                            res.data.errors.forEach(function (value) {
                                fields += state.$t(value.id)+";<br/>";
                            });
                            this.titleToast = this.$t(res.data.messageId);
                            this.messageToast = this.$t(fields);
                        }else if (res.data.messageId === 'response.already.exists'){
                            this.messageToast = this.$t('response.company.already.exists');
                        }else{
                            this.messageToast = this.$t(res.data.messageId);
                            this.messageIdToast = res.data.messageId;
                        }

                        $('#toast').modal('show');
                    }
                    console.log(JSON.stringify(error));
            });
        },
         loadTypeServices: function(payload){
                let query = {
                type: type
            };
            setTimeout(async function(){
                let responseCertifies = (await Request.do(payload, 'GET', Request.getDefaultHeader(payload), {}, `${Endpoints.parts.certifies.list}`)).data;
                payload.certifies = responseCertifies.results;
                let responseServices = (await Request.do(payload, 'POST', Request.getDefaultHeader(payload), {type: "SERVICE"}, `${Endpoints.parts.families.listByType}`)).data;
                payload.services = responseServices.results;
            }, 100);
        },
        archive: function(response){
            if (response==1){
                $('#spinner').modal('toggle');
                this.errors = [];
                this.messageIdToast = null;
                let state = this;
                this.data.document = this.data.document.replace(/\//g, '').replace(/\./g, '').replace(/\-/g, '');
                Request.do(this, 'DELETE', Request.getDefaultHeader(this), this.data, `${Endpoints.companies.company}${this.data.document ? this.data.document : ''}`,
                    (companyResponse)=>{//SUCCESS CALLBACK
                        $('#spinner').modal('toggle');
                        this.$eventHub.$emit('refreshList');
                        this.flashMessage.warning(
                            this.configMessage(this.$t('string.msg.company.register.title.filed'), this.$t('string.msg.company.register.message.filed'), 'top left', 3000),
                        {
                            mounted: this.showText(this.$t('string.msg.company.register.message.filed')),
                            destroyed: this.clearText()
                        })
                    },
                    (error)=>{//ERROR CALLBACK
                        $('#spinner').modal('toggle');
                        let res = error.response;
                        if (res && res.status){
                            this.titleToast = this.$t("string.msg.warning");
                            if (res.data.messageId === 'response.msg.error.empty.fields'){
                                let fields = "";
                                res.data.errors.forEach(function (value) {
                                    fields += state.$t(value.id)+";<br/>";
                                });
                                this.titleToast = this.$t(res.data.messageId);
                                this.messageToast = this.$t(fields);
                            }else{
                                this.messageToast = this.$t(res.data.messageId);
                                this.messageIdToast = res.data.messageId;
                            }

                            $('#toast').modal('show');
                        }
                        console.log(JSON.stringify(error));
                });
            }
        },
        confirmArchive: function(item){
            this.titleToast = this.$t("string.msg.confirm");
            this.messageToast = this.$t("response.archive.company.confirmation");
            this.cancelText = this.$t("string.msg.cancel");
            this.yesText = this.$t("string.msg.yes");
            $('#confirmationModal').modal('show');
        },
        loadGeolocation: function (callbackSuccess, callbackError) {
            let state = this;
            Request.do(this, 'POST', Request.getDefaultHeader(this), this.data.address, `${Endpoints.addresses.geolocation}`,
                    (geoResponse)=>{//SUCCESS CALLBACK
                        if (geoResponse.results.length==0){
                            return callbackError(this.$t('string.company.register.address.invalid'));
                        }else if (geoResponse.results.length==1){
                            let geo = geoResponse.results[0];
                            let addressObj = instanceateAddress(state.data.address, geoResponse.results[0]);
                            console.log('geoResponse.results');
                            console.log(JSON.stringify(addressObj));
                            if (addressObj){
                        
                                return callbackSuccess(state.data);
                            }else {
                                // state.data.address
                                return callbackError(state.$t('string.company.register.address.invalid'));
                            }
                        }else if (geoResponse.results.length>1){
                            state.addresses = geoResponse.results;
                            $('#modalListAddress').modal('toggle');
                        } 
                    },
                    (error)=>{//ERROR CALLBACK
                        let res = error.response;
                        if (res && res.status){
                            this.titleToast = this.$t("string.msg.warning");
                            if (res.data.messageId === 'response.msg.error.empty.fields'){
                                let fields = "";
                                res.data.errors.forEach(function (value) {
                                    fields += state.$t(value.id)+";<br/>";
                                });
                                this.titleToast = this.$t(res.data.messageId);
                                this.messageToast = this.$t(fields);
                            }else if (res.data.messageId === 'response.already.exists'){
                                this.messageToast = this.$t('response.user.already.exists');
                            }else{
                                this.messageToast = this.$t(res.data.messageId);
                                this.messageIdToast = res.data.messageId;
                            }

                            $('#toast').modal('show');
                        }
                        
                    });        
        },
        selectAddress: function(index){
            let addressObj = instanceateAddress(this.data.address, this.addresses[index]);
            
            if (addressObj){
                addressObj.ibge = this.data.address.ibge;
                addressObj.gia = this.data.address.gia;
                addressObj.complement = this.data.complement;
                this.data.address = addressObj;
                $('#modalListAddress').modal('toggle');
                this.save(this.data);
            }else {
                this.errors = [];
                this.errors.push(this.$t('string.company.register.address.invalid'));
                 $('#modalListAddress').modal('toggle');
            }
        },
        loadInfosByCEP: function(){
            let state = this;
            if (this.data.address.cep && this.data.address.cep.length == 9){
                $('#spinner').modal('toggle');
                Request.do(this, 'GET', {}, {}, `${Endpoints.cep.find}${this.data.address.cep}/json`,
                    (response)=>{//SUCCESS CALLBACK
                        if (response){
                            state.data.address.address = response.logradouro;
                            state.data.address.neighborhood = response.bairro;
                            state.data.address.city = response.localidade;
                            state.data.address.state = response.uf;
                            state.data.address.ibge = response.ibge;
                            state.data.address.gia = response.gia;
                        }
                        
                        $('#spinner').modal('toggle');
                    },
                    (error)=>{//ERROR CALLBACK
                        $('#spinner').modal('toggle');
                        
                        console.log(JSON.stringify(error));
                });
            }
        },
        checkForm: function (e) {
            this.errors = [];
            if (!this.data.fantasyName) {
                this.errors.push(this.$t('response.user.register.fantasyName.required'));
            }
            if (!this.data.socialName) {
                this.errors.push(this.$t('response.user.register.socialName.required'));
            }
            if (!this.data.document) {
                this.errors.push(this.$t('response.user.register.document.required'));
            }
            if (this.data.typeService == -1) {
                this.errors.push(this.$t('response.user.register.typeService.required'));
            }
            if (this.data.isBranch && !this.data.mainCompany) {
                this.errors.push(this.$t('response.user.register.document.maincompany'));
            }
            if (!this.data.address.cep) {
                this.errors.push(this.$t('response.address.register.cep.required'));
            }
            if (this.data.address.state == -1) {
                this.errors.push(this.$t('response.address.register.city.state.required'));
            }
            if (!this.data.address.city) {
                this.errors.push(this.$t('response.address.register.city.required'));
            }
            if (!this.data.address.neighborhood) {
                this.errors.push(this.$t('response.address.register.neighborhood.required'));
            }
            if (!this.data.address.address) {
                this.errors.push(this.$t('response.address.register.address.required'));
            }
            if (!this.data.address.number) {
                this.errors.push(this.$t('response.address.register.number.required'));
            }

            if (this.errors.length>0){
                e.preventDefault();
            }else{
                this.loadGeolocation(
                    (newData)=>{
                        this.save(newData);
                    },
                    (error)=>{
                        this.errors.push(error);
                    });
            }
        },
        selectItem: function(item){
            this.loadTypeServices(this);
            console.log(item);
            this.data = JSON.parse(JSON.stringify(item));
            this.data.address.state = this.data.address.state.toUpperCase();
            this.data.fantasyName = Common.camelize(this.data.fantasyName);
            this.data.socialName = Common.camelize(this.data.socialName);
            this.data.address.address =  Common.camelize(this.data.address.address);
            this.data.address.city =  Common.camelize(this.data.address.city);
            this.data.address.neighborhood =  Common.camelize(this.data.address.neighborhood);
            this.data.document = this.data.document.replace(/\//g, '').replace(/\./g, '').replace(/\-/g, '');
            this.lastDocument = this.data.document.replace(/\//g, '').replace(/\./g, '').replace(/\-/g, '');
            if(this.data.address.complement)
            {
                 this.data.address.complement =  Common.camelize(this.data.address.complement);
            }
            console.log(this.data);
            document.body.scrollTop = 0; // For Safari
            document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
        },
        showText(text) {
            this.text = text
        },
        clearText() {
            setTimeout( () => this.text = '', 500);
        },
        clearForm: function(){
            this.data = {};
        },
        listManufacturer: function () {
            return this.data.manufacturerFamilies.filter(i => i.type === 'TRUCK_TRAILER')
        },
        listFamilies: function (item) {
            return item.families.filter(i => i.type === 'TRUCK_TRAILER')
        },
        listManufacturerTruck: function () {
            return this.data.manufacturerFamilies.filter(i => i.type === 'TRUCK')
        },
        listFamiliesTruck: function (item) {
            return item.families.filter(i => i.type === 'TRUCK')
        },
       
        selectAll: function(){
            if (!this.isAllSelected){
                let state = this;
                this.data.families = [];
                this.families.forEach(function (item) {
                    if (item && item._id)
                        state.data.families.push(item._id);
                });
                this.isAllSelected = true;
            }else{
                this.data.families = [];
                this.isAllSelected = false;
            }
            
        },
        configMessage :function(title, message, position, time){
            const config ={
               title: title,
                message: message,
                position: position,
                x: window.innerWidth /60,
                y: window.innerHeight /1.3,
                time: time,
            }
            return config
        },
        camelize: Common.toUpperCase,
        getType: type
       
    }
}
</script>
